import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/new-password.svg'
import _imports_1 from '@/assets/authentication.svg'
import _imports_2 from '@/assets/password.svg'
import _imports_3 from '@/assets/checkmark.gif'


const _hoisted_1 = {
  key: 0,
  class: "flex flex-col w-full h-full p-6 items-center justify-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center align-center h-4/5 w-full" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full h-full",
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_3 = { class: "col-md-7 p-4 modal-column" }
const _hoisted_4 = {
  key: 0,
  class: "text-center pb-2 font-bold text-sm"
}
const _hoisted_5 = {
  key: 1,
  class: "text-center pb-2 font-bold text-sm"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Vamos lá! ")
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col items-center h-full justify-center w-full"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-3/5",
  src: _imports_1,
  alt: "Analisando dados"
}, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "font-bold text-gray-500 w-4/5"
}
const _hoisted_10 = {
  key: 1,
  class: "font-bold text-red-500 w-4/5"
}
const _hoisted_11 = { class: "flex flex-col items-center mt-4" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Verificar ")
const _hoisted_13 = {
  key: 2,
  class: "flex flex-col items-center h-full p-8 justify-center w-full"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-3/5",
  src: _imports_2,
  alt: "Analisando dados"
}, null, -1)
const _hoisted_15 = { class: "flex flex-col w-full" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-left text-sm mb-4" }, " A sua nova senha segura deve conter: ", -1)
const _hoisted_17 = { class: "text-left text-sm flex items-center" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Pelo menos 8 caracteres. ")
const _hoisted_19 = { class: "text-left text-sm flex items-center" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Pelo menos um caractere maiúsculo (A-Z); ")
const _hoisted_21 = { class: "text-left text-sm flex items-center" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Pelo menos um caractere minúsculo (a-z); ")
const _hoisted_23 = { class: "text-left text-sm flex items-center" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Pelo menos um caractere númerico (0-9) ")
const _hoisted_25 = { class: "text-left text-sm flex items-center mb-4" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Pelo menos um caractere especial (*, @, !, $, %, ...); ")
const _hoisted_27 = { class: "flex justify-between" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Mudar Senha ")
const _hoisted_29 = {
  key: 3,
  class: "flex flex-col items-center"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-4/5",
  src: _imports_3,
  alt: "Analisando dados"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-lg" }, "Senha alterada com sucesso!", -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spin = _resolveComponent("Spin")!
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_Code = _resolveComponent("Code")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    width: "35%",
    height: _ctx.formWizardSteps.stepTree ? '90%' : '80%',
    onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "flex flex-row w-full h-full",
        onSubmit: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
      }, [
        (_ctx.formWizardSteps.stepOne)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                (!_ctx.isExpired)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Olá caro usuário, por motivos de segurança, todos os nossos usuários devem alterar suas senhas. Mas não se preocupe, vamos te ajudar a escolher uma senha segura! "))
                  : (_openBlock(), _createElementBlock("p", _hoisted_5, " Olá caro usuário, sua senha expirou, por motivos de segurança, você precisa alterar sua senha, Mas não se preocupe, vamos te ajudar a escolher uma senha segura! "))
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToNextStep(1, 2))),
                  class: "pb-2 pt-2 pr-16 pl-16 bg-dpc hover:bg-green-700 text-white rounded flex items-center"
                }, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_Spin, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_vue_feather, {
                        key: 1,
                        "stroke-width": "3",
                        size: "15",
                        class: "mr-2",
                        type: "arrow-right"
                      })),
                  _hoisted_6
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.formWizardSteps.stepTwo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              (!_ctx.errorCodeMessage)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Foi enviado um código de verificação para o seu email por favor digite o código abaixo para continuar. "))
                : (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.errorCodeMessage), 1)),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Code, {
                  length: 7,
                  onValue: _cache[1] || (_cache[1] = ($event: any) => (_ctx.verifyCode($event)))
                }),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkVerifyCode())),
                  class: "pb-2 pt-2 pr-16 pl-16 mt-5 mb-4 bg-dpc hover:bg-green-700 text-white rounded flex items-center"
                }, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_Spin, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_vue_feather, {
                        key: 1,
                        "stroke-width": "3",
                        size: "15",
                        class: "mr-2",
                        type: "shield"
                      })),
                  _hoisted_12
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.formWizardSteps.stepTree)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("p", _hoisted_17, [
                  _createVNode(_component_vue_feather, {
                    "stroke-width": "3",
                    size: "15",
                    class: _normalizeClass(["mr-2", _ctx.requirimentsIcon(_ctx.validationLength, 'text')]),
                    type: _ctx.requirimentsIcon(_ctx.validationLength, 'icon')
                  }, null, 8, ["class", "type"]),
                  _hoisted_18
                ]),
                _createElementVNode("p", _hoisted_19, [
                  _createVNode(_component_vue_feather, {
                    "stroke-width": "3",
                    size: "15",
                    class: _normalizeClass(["mr-2", _ctx.requirimentsIcon(_ctx.validationMaiuscula, 'text')]),
                    type: _ctx.requirimentsIcon(_ctx.validationMaiuscula, 'icon')
                  }, null, 8, ["class", "type"]),
                  _hoisted_20
                ]),
                _createElementVNode("p", _hoisted_21, [
                  _createVNode(_component_vue_feather, {
                    "stroke-width": "3",
                    size: "15",
                    class: _normalizeClass(["mr-2", _ctx.requirimentsIcon(_ctx.validationMinuscula, 'text')]),
                    type: _ctx.requirimentsIcon(_ctx.validationMinuscula, 'icon')
                  }, null, 8, ["class", "type"]),
                  _hoisted_22
                ]),
                _createElementVNode("p", _hoisted_23, [
                  _createVNode(_component_vue_feather, {
                    "stroke-width": "3",
                    size: "15",
                    class: _normalizeClass(["mr-2", _ctx.requirimentsIcon(_ctx.validationNumerico, 'text')]),
                    type: _ctx.requirimentsIcon(_ctx.validationNumerico, 'icon')
                  }, null, 8, ["class", "type"]),
                  _hoisted_24
                ]),
                _createElementVNode("p", _hoisted_25, [
                  _createVNode(_component_vue_feather, {
                    "stroke-width": "3",
                    size: "15",
                    class: _normalizeClass(["mr-2", _ctx.requirimentsIcon(_ctx.validationEspecial, 'text')]),
                    type: _ctx.requirimentsIcon(_ctx.validationEspecial, 'icon')
                  }, null, 8, ["class", "type"]),
                  _hoisted_26
                ]),
                _createElementVNode("p", {
                  class: _normalizeClass(["mb-2 text-sm", _ctx.errorMessage ? 'text-red-600' : 'text-transparent'])
                }, _toDisplayString(_ctx.errorMessage || "dfdf"), 3)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _withDirectives(_createElementVNode("input", {
                  class: "shadow appearance-none border rounded w-2/4 mr-2 py-2 mb-4 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline",
                  id: "password",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event)),
                  type: "password",
                  placeholder: "Nova Senha"
                }, null, 512), [
                  [_vModelText, _ctx.password]
                ]),
                _withDirectives(_createElementVNode("input", {
                  class: "shadow appearance-none border rounded w-2/4 py-2 mb-4 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline",
                  id: "passwordConfirm",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                  type: "password",
                  placeholder: "Confirmar nova senha"
                }, null, 512), [
                  [_vModelText, _ctx.confirmPassword]
                ])
              ]),
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changePassword())),
                class: "pb-2 pt-2 pr-16 pl-16 mt-2 mb-2 bg-dpc hover:bg-green-700 text-white rounded flex items-center"
              }, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createBlock(_component_Spin, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_vue_feather, {
                      key: 1,
                      "stroke-width": "3",
                      size: "15",
                      class: "mr-2",
                      type: "key"
                    })),
                _hoisted_28
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.formWizardSteps.stepFour)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_32))
          : _createCommentVNode("", true)
      ], 32)
    ]),
    _: 1
  }, 8, ["height"]))
}